// import React from 'react';
// import { 
//   Gavel, Scale, ShieldAlert, Landmark, 
//   FileText, ArrowLeft, ShieldCheck, ClipboardCheck,
//   UserCheck, AlertCircle
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function LitigationServices() {
  
//   // Array of courts the firm pleads before
//   const judicialBodies = [
//     {
//       title: "المحاكم التجارية",
//       desc: "الترافع في منازعات الشركات، العقود التجارية، الإفلاس، والوكالات التجارية وحماية الأصول الاستثمارية.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "المحاكم العامة والمدنية",
//       desc: "تمثيل العملاء في النزاعات العقارية الكبرى، دعاوى التعويضات، ومنازعات العقود والالتزامات المالية.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "ديوان المظالم (المحاكم الإدارية)",
//       desc: "مواجهة القرارات الإدارية التعسفية الصادرة من الجهات الحكومية، ودعاوى العقود والمشاريع العامة.",
//       icon: <Gavel className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "المحاكم واللجان العمالية",
//       desc: "الدفاع عن حقوق المنشآت أو الكوادر التنفيذية في نزاعات الأجور، مكافآت نهاية الخدمة، والفصل التعسفي.",
//       icon: <UserCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "محاكم التنفيذ",
//       desc: "تحويل الأحكام القضائية والأوراق التجارية (السندات لأمر، الشيكات، العقود الموثقة) إلى واقع مالي ملموس.",
//       icon: <ClipboardCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "اللجان شبه القضائية",
//       desc: "مثل اللجان المصرفية، اللجان الجمركية، لجان منازعات التأمين، واللجان الضريبية والتمويلية.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="التقاضي والترافع والتمثيل القضائي"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">الدفاع القانوني الاحترافي</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">التقاضي والترافع والتمثيل القضائي</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             حماية حقوقك أمام الجهات القضائية تتطلب شريكاً قانونياً يمتلك المعرفة العميقة بالأنظمة، والخبرة الميدانية بصياغة اللوائح والاعتراضات وإدارة الجلسات القضائية بذكاء وحزم.
//           </p>
//         </div>
//       </section>

//       {/* Strategic Value Approach */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
//           <div className="lg:col-span-2">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-4">فلسفتنا في إدارة الدعاوى القضائية</h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               نحن لا ننظر إلى التقاضي كأول خيار، بل ندرسه كخيار استراتيجي حاسم. عندما يتطلب الموقف النزاع القضائي، فإن فريقنا يتحرك وفق إستراتيجية دفاعية أو هجومية مدروسة بعناية لتأمين أعلى نسب النجاح الممكنة.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               نقوم بإعداد لوائح الادعاء واللوائح الجوابية، صياغة مذكرات الاعتراض والاستئناف، ومتابعة القضية عبر منصات القضاء الرقمية (مثل منصة ناجز) حتى صدور حكم قطعي وتنفيذه.
//             </p>
//           </div>
//           <div className="bg-amber-50 p-6 rounded-xl border border-amber-200/60 flex flex-col justify-center items-center text-center">
//             <ShieldAlert className="w-16 h-16 text-amber-600 mb-3" />
//             <span className="font-bold text-slate-800 text-lg">بناء الموقف القانوني</span>
//             <p className="text-gray-500 text-sm mt-1">قوة قضيتك تعتمد بالدرجة الأولى على طريقة ترتيب الأدلة وتقديم الأسانيد الشرعية والنظامية المباشرة.</p>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Courts and Panels */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">الجهات القضائية التي نمثلك أمامها</h2>
//           <p className="text-gray-500">خبرتنا ممتدة عبر المنظومة العدلية المتكاملة في المملكة العربية السعودية</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {judicialBodies.map((body, index) => (
//             <div key={index} className="bg-white p-6 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300 flex flex-col justify-between">
//               <div>
//                 <div className="p-3 bg-slate-100 rounded-lg w-fit text-slate-700 mb-4">
//                   {body.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-800 mb-2">{body.title}</h3>
//                 <p className="text-gray-500 text-sm leading-relaxed">{body.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Horizontal Timeline Block: Suit Lifecycle */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">رحلة القضية والدفاع معنا</h2>
//             <p className="text-slate-400">آلية واضحة وممنهجة تضمن الشفافية واطلاع العميل على كافة التطورات</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
            
//             {/* Step 1 */}
//             <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 relative">
//               <span className="text-amber-500 text-xs font-bold block mb-1">المرحلة الأولى</span>
//               <h3 className="text-lg font-bold mb-2">الدراسة والتقييم</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">فحص المستندات والأدلة بدقة، وتحليل المخاطر لتحديد فرص النجاح وبناء التكييف القانوني السليم.</p>
//             </div>

//             {/* Step 2 */}
//             <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 relative">
//               <span className="text-amber-500 text-xs font-bold block mb-1">المرحلة الثانية</span>
//               <h3 className="text-lg font-bold mb-2">القيد والصياغة</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">تحرير صحيفة الدعوى متضمنة الأسانيد النظامية والطلبات الختامية، وقيدها رسمياً عبر الأنظمة الإلكترونية المعتمدة.</p>
//             </div>

//             {/* Step 3 */}
//             <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 relative">
//               <span className="text-amber-500 text-xs font-bold block mb-1">المرحلة الثالثة</span>
//               <h3 className="text-lg font-bold mb-2">المرافعة والمدافعة</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">حضور الجلسات القضائية (المرئية والكتابية)، تقديم المذكرات الجوابية والتعقيبية وردود المرافعة بحنكة عالية.</p>
//             </div>

//             {/* Step 4 */}
//             <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 relative">
//               <span className="text-amber-500 text-xs font-bold block mb-1">المرحلة الرابعة</span>
//               <h3 className="text-lg font-bold mb-2">الاستئناف والتنفيذ</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">إعداد لوائح الاعتراض في حال الحاجة، والبدء الفوري في إجراءات التنفيذ الجبري عبر قضاء التنفيذ لاسترداد الحقوق.</p>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* Call to Action Footer Note */}
//       <section className="max-w-3xl mx-auto py-16 px-4 text-center">
//         <div className="inline-flex p-3 bg-amber-50 rounded-full text-amber-700 mb-4">
//           <ShieldCheck className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل لديك نزاع قضائي يتطلب تدخلاً فورياً؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">تأخير اتخاذ الإجراء القانوني الصحيح أو فوات مواعيد تقديم الطعون قد يعرض مركزك المالي والقانوني للخطر المستمر.</p>
//         <button className="bg-slate-950 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-slate-800 transition-colors">
//           تواصل مع مستشارينا الآن
//         </button>
//       </section>

//     </div>
//   );
// }



import React from 'react';
import { 
  Gavel, Scale, ShieldAlert, Landmark, 
  FileText, ArrowLeft, ShieldCheck, ClipboardCheck,
  UserCheck, AlertCircle
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function LitigationServices() {
  
  // Array of courts the firm pleads before - Refactored to Navy Light
  const judicialBodies = [
    {
      title: "المحاكم التجارية",
      desc: "الترافع في منازعات الشركات، العقود التجارية، الإفلاس، والوكالات التجارية وحماية الأصول الاستثمارية.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "المحاكم العامة والمدنية",
      desc: "تمثيل العملاء في النزاعات العقارية الكبرى، دعاوى التعويضات، ومنازعات العقود والالتزامات المالية.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "ديوان المظالم (المحاكم الإدارية)",
      desc: "مواجهة القرارات الإدارية التعسفية الصادرة من الجهات الحكومية، ودعاوى العقود والمشاريع العامة.",
      icon: <Gavel className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "المحاكم واللجان العمالية",
      desc: "الدفاع عن حقوق المنشآت أو الكوادر التنفيذية في نزاعات الأجور، مكافآت نهاية الخدمة، والفصل التعسفي.",
      icon: <UserCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "محاكم التنفيذ",
      desc: "تحويل الأحكام القضائية والأوراق التجارية (السندات لأمر، الشيكات، العقود الموثقة) إلى واقع مالي ملموس.",
      icon: <ClipboardCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "اللجان شبه القضائية",
      desc: "مثل اللجان المصرفية، اللجان الجمركية، لجان منازعات التأمين، واللجان الضريبية والتمويلية.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="التقاضي والترافع والتمثيل القضائي"
        description="نقدم استراتيجيات مرافعة ومدافعة متكاملة لحماية حقوقك ومصالحك أمام الجهات القضائية"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('[https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80](https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80)'        )] bg-cover bg-center"></div>
        {/* White/Slate overlay for modern executive contrast */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">الدفاع القانوني الاحترافي</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">التقاضي والترافع والتمثيل القضائي</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            حماية حقوقك أمام الجهات القضائية تتطلب شريكاً قانونياً يمتلك المعرفة العميقة بالأنظمة، والخبرة الميدانية بصياغة اللوائح والاعتراضات وإدارة الجلسات القضائية بذكاء وحزم.
          </p>
        </div>
      </section>

      {/* Strategic Value Approach */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-2">
            <h2 className="text-2xl md:text-3xl font-extrabold text-indigo-950 mb-4">فلسفتنا في إدارة الدعاوى القضائية</h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              نحن لا ننظر إلى التقاضي كأول خيار، بل ندرسه كخيار استراتيجي حاسم. عندما يتطلب الموقف النزاع القضائي، فإن فريقنا يتحرك وفق إستراتيجية دفاعية أو هجومية مدروسة بعناية لتأمين أعلى نسب النجاح الممكنة.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              نقوم بإعداد لوائح الادعاء واللوائح الجوابية، صياغة مذكرات الاعتراض والاستئناف، ومتابعة القضية عبر منصات القضاء الرقمية (مثل منصة ناجز) حتى صدور حكم قطعي وتنفيذه.
            </p>
          </div>
          
          {/* Executive Sidebar - Refactored to Navy Light Style */}
          <div className="bg-slate-50 p-6 rounded-xl border border-slate-200/60 flex flex-col justify-center items-center text-center shadow-sm">
            <ShieldAlert className="w-16 h-16 text-indigo-950 mb-3" />
            <span className="font-bold text-indigo-950 text-lg">بناء الموقف القانوني</span>
            <p className="text-slate-500 text-sm mt-2 font-light leading-relaxed">قوة قضيتك تعتمد بالدرجة الأولى على طريقة ترتيب الأدلة وتقديم الأسانيد الشرعية والنظامية المباشرة.</p>
          </div>
        </div>
      </section>

      {/* Grid: Courts and Panels - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">الجهات القضائية التي نمثلك أمامها</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">خبرتنا ممتدة عبر المنظومة العدلية المتكاملة في المملكة العربية السعودية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {judicialBodies.map((body, index) => (
              <div key={index} className="bg-white p-6 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between">
                <div>
                  <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
                    {body.icon}
                  </div>
                  <h3 className="text-xl font-bold text-indigo-950 mb-2">{body.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed font-light">{body.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Horizontal Timeline Block: Suit Lifecycle - Converted completely to Premium Light Grid */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">رحلة القضية والدفاع معنا</h2>
          <p className="text-slate-500 text-sm md:text-base font-light">آلية واضحة وممنهجة تضمن الشفافية واطلاع العميل على كافة التطورات</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
          
          {/* Step 1 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">المرحلة الأولى</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">الدراسة والتقييم</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">فحص المستندات والأدلة بدقة، وتحليل المخاطر لتحديد فرص النجاح وبناء التكييف القانوني السليم.</p>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">المرحلة الثانية</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">القيد والصياغة</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">تحرير صحيفة الدعوى متضمنة الأسانيد النظامية والطلبات الختامية، وقيدها رسمياً عبر الأنظمة الإلكترونية المعتمدة.</p>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">المرحلة الثالثة</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">المرافعة والمدافعة</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">حضور الجلسات القضائية (المرئية والكتابية)، تقديم المذكرات الجوابية والتعقيبية وردود المرافعة بحنكة عالية.</p>
          </div>

          {/* Step 4 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">المرحلة الرابعة</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">الاستئناف والتنفيذ</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">إعداد لوائح الاعتراض في حال الحاجة، والبدء الفوري في إجراءات التنفيذ الجبري عبر قضاء التنفيذ لاسترداد الحقوق.</p>
          </div>

        </div>
      </section>

      {/* Call to Action Footer Note - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <ShieldCheck className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل لديك نزاع قضائي يتطلب تدخلاً فورياً؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">تأخير اتخاذ الإجراء القانوني الصحيح أو فوات مواعيد تقديم الطعون قد يعرض مركزك المالي والقانوني للخطر المستمر.</p>
        <button 
          onClick={() => openWhatsApp( "  تواصل مع مستشارينا الآن   ")}
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm">
          تواصل مع مستشارينا الآن
        </button>
      </section>

    </div>
  );
}